import React from "react"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import MainAutopautaMG from "../../atoms/main-autopauta-mg/main-autopauta-mg"
import MainAutopautaUsers from "../../atoms/main-autopauta-users/main-autopauta-users"
import "./category-menu-mg.scss"

const CategoryMenuMG = props => {

  const userInfoEncrypt= encryptUserInfo()
  const categoryDatalayer = category => {
    pushDataLayerEvent({
      event: "Interacciones - Menú Vertical",
      category: "menu_vertical",
      action: "click",
      label: category,
      sub_category: "nuestro mundo",
      Location: window.location.href,
      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
      log_status: userInfoEncrypt.log_status,
    })
  }
  
  //Desktop
  if (!props.mobile) {
    return (
      <aside className="f-category-menu-container">
        <div className="f-top-filter-menu">
          <ul className="f-category-menu-list">
            {props.categories.map((categoryItem, index) => {
              return (
                <li
                  className="f-category-item"
                  key={index}
                  onClick={() => {
                    props.filterCategory(categoryItem.slug)
                    props.setCategory(categoryItem.slug)
                    props.persistCategory(
                      categoryItem.slug,
                      categoryItem.titulo
                    )
                    categoryDatalayer(categoryItem.titulo)
                  }}
                >
                  <h2
                    className={
                      "f-title-category " +
                      (props.activeCategory === categoryItem.slug
                        ? "active-category-bold"
                        : null)
                    }
                  >
                    {categoryItem.titulo}
                  </h2>
                  {props.activeCategory === categoryItem.slug && (
                    <span className="f-active-icon-flag"></span>
                  )}
                </li>
              )
            })}
          </ul>
        </div>
        {props.activeCategory !== "articulos-usuarias" && (
          <MainAutopautaMG autopauta={props.autopauta[0]} />
        )}
        {props.activeCategory === "articulos-usuarias" && (
          <MainAutopautaUsers autopauta={props.autopauta[1]} />
        )}
      </aside>
    )
    // Mobile
  } else {
    return (
      <div
        className={
          props.searchActive
            ? "menu-search-active"
            : "f-category-menu-container-mobile"
        }
      >
        <div
          className="f-menu-category-activator"
          onClick={() => props.setStatusMenuCategory(true)}
        >
          {!props.searchActive && (
            <>
              <label className="f-activator-title">Ver más temas</label>
              <span className="f-icon icon-down f-icon-activator" />
            </>
          )}
        </div>
      </div>
    )
  }
}

export default CategoryMenuMG
